import React, { Component } from 'react';

import { connect } from "react-redux";
import { history } from "../../_helpers"; 
import { SlPageTitle, SlRadioButton,  SlButton, SlFormEntryRow, SlSectionTitle} from "../editors"
import { registrationActions } from "../../_actions";
import { metadataService, SessionService } from '../../_services';
import { Row, Col } from 'reactstrap';


class PaymentSuccess extends Component {
    static displayName = PaymentSuccess.name;

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    submitClick = () => {
        if (this.props.hasAccount)
            history.push('/LogInMain');
        else {
            this.props.actions.guestPaymentRegistration(this.props.userHash);
        }
    }

    render() {
        return (
            <div className="PaymentSuccess">                
                <SlPageTitle pageName="PaymentSuccess" />

                <Row>
                    <Col>
                        <p className="text-center" style={{ marginBottom: "0em", fontWeight: "bold" }}>
                            {metadataService.getMessage(this.props.hasAccount ? 'PaymentSuccessExistingAccount' : 'PaymentSuccessNewAccount')}
                        </p>
                        <ul className="h6-title-margin">
                            <li>{metadataService.getMessage('PaymentSuccessNewAccount1')}</li>
                            <li>{metadataService.getMessage('PaymentSuccessNewAccount2')}</li>
                            <li>{metadataService.getMessage('PaymentSuccessNewAccount3')}</li>
                            <li>{metadataService.getMessage('PaymentSuccessNewAccount4')}</li>
                            <li>{metadataService.getMessage('PaymentSuccessNewAccount5')}</li>
                        </ul>
                    </Col>
                </Row>

                <div className="text-center">
                    <SlButton name={this.props.hasAccount ? "SignIn" : "CreateAnAccount"} size="lg" onClick={this.submitClick} />
                </div>
            </div>
        );
    }



}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;

    return {
        loggedIn
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            guestPaymentRegistration: (userHash) => {
                dispatch(registrationActions.guestPaymentRegistration(userHash));
            }
        },

    }
}

const connectedPaymentSuccess = connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess);
export { connectedPaymentSuccess as PaymentSuccess };


// WEBPACK FOOTER //
// ./src/components/subcomponents/PaymentSuccess.js